function getPercentageFromTwoNumbers(large: number, small: number): number {
  return (small / large) * 100;
}

export default getPercentageFromTwoNumbers;
